import type { DeeplinkValid } from '~/types/Deeplink';
import axios from 'axios';

export default function useDeeplink() {
    const URL = useRuntimeConfig().public.API_URL;

    async function isValidDeeplink(deeplinkId: string) {
        const { data } = await axios<DeeplinkValid>(`${URL}/v1/deeplinks/${deeplinkId}/is-valid`, {
            method: 'POST',
        });

        return !!data.isValid;
    }

    async function createVisitLog(deeplinkId: string, referer?: string) {
        const { data } = await axios(`${URL}/v1/deeplinks/${deeplinkId}/visitor-log`, {
            method: 'POST',
            data: referer ? { referer } : undefined,
        });
        return data;
    }

    async function collectUser(payload: { deeplinkId: string; accessToken: string }) {
        const { data } = await axios(`${URL}/v1/deeplinks/collect`, {
            method: 'POST',
            data: {
                deeplinkId: payload.deeplinkId,
                accessToken: payload.accessToken,
            },
        });
        return data;
    }

    return {
        isValidDeeplink,
        createVisitLog,
        collectUser,
    };
}
